/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Response_ExamplesInputs */

const en_directory_agent_readiness_check_response_examples = /** @type {(inputs: Directory_Agent_Readiness_Check_Response_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response examples`)
};

const zh_directory_agent_readiness_check_response_examples = /** @type {(inputs: Directory_Agent_Readiness_Check_Response_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应示例`)
};

/**
* | output |
* | --- |
* | "Response examples" |
*
* @param {Directory_Agent_Readiness_Check_Response_ExamplesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_response_examples = /** @type {((inputs?: Directory_Agent_Readiness_Check_Response_ExamplesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Response_ExamplesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_response_examples(inputs)
	return zh_directory_agent_readiness_check_response_examples(inputs)
});
export { directory_agent_readiness_check_response_examples as "directory.agent_readiness.check.response_examples" }